import React from "react"

const Calendly = () => {
  return (
    <div style={{ height: "650px" }}>
      <iframe
        title={"Set Calendly schedule"}
        src="https://calendly.com/vishwa/15min"
        width="100%"
        height="100%"
        frameborder="0"
      />
    </div>
  )
}

export default Calendly
